import React from 'react';

export default class IntencionVacunarse extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>3. </strong> &nbsp;
          ¿Desea usted vacunarse contra COVID-19?
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={datos.intencion}
              onChange={(e) => editar('intencion', e.target.checked)}
            />
            Si
          </label>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={!datos.intencion}
              onChange={(e) => editar('intencion', !e.target.checked)}
            />
            No
          </label>
          {!datos.intencion &&
            <span style={{margin:3}}>
              Recordar medidas generales de prevención y RETIRARSE DEL DOMICILIO
              <br/>
              <strong>FINALIZAR ENCUESTA</strong>
            </span>
          }
        </div>
      </div>
    )
  }
}
